import { Typography } from '@mui/material';

import { isEffectivelyZero } from '~/shared/utils/isEffectivelyZero';

type CellValueProps = {
  value: string | number;
};

export function CellValue({ value }: CellValueProps) {
  const isEmpty = value === '' || value === null || value === undefined;
  if (isEmpty || isEffectivelyZero(value)) {
    return (
      <Typography variant="body2" color="text.disabled">
        —
      </Typography>
    );
  }
  return <Typography variant="body2">{value}</Typography>;
}
